import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { AircraftTypeListItem } from "./AircraftTypeListItem";
import { AircraftType } from "@/types/flight";

interface AircraftTypeListProps {
  aircraftTypes: AircraftType[];
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export function AircraftTypeList({ aircraftTypes, onEdit, onDelete }: AircraftTypeListProps) {
  // Group aircraft types alphabetically by first letter
  const groupedAircraftTypes = aircraftTypes.reduce((acc, aircraftType) => {
    const firstLetter = aircraftType.name.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(aircraftType);
    return acc;
  }, {} as Record<string, AircraftType[]>);

  // Sort letters alphabetically
  const sortedLetters = Object.keys(groupedAircraftTypes).sort();

  return (
    <div className="border rounded-lg">
      <Accordion type="multiple" className="w-full">
        {sortedLetters.map((letter) => (
          <AccordionItem key={letter} value={letter}>
            <AccordionTrigger className="px-4 py-3 text-left">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-lg">{letter}</span>
                <Badge variant="secondary" className="ml-2">
                  {groupedAircraftTypes[letter].length} aircraft types
                </Badge>
              </div>
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-3">
              <div className="space-y-2">
                {groupedAircraftTypes[letter]
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((aircraftType) => (
                    <AircraftTypeListItem
                      key={aircraftType.id}
                      aircraftType={aircraftType}
                      onEdit={onEdit}
                      onDelete={onDelete}
                    />
                  ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}